import { render, staticRenderFns } from "./input-number-format.vue?vue&type=template&id=ba629da4&"
import script from "./input-number-format.vue?vue&type=script&lang=js&"
export * from "./input-number-format.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports